import { Typography, useTheme, Box } from "@mui/material"
import { tokens } from "../theme"

const Header = ({title, subtitle}) => {
  return <Box mb="30px">
    <Typography 
       variant="h1" 
       fontWeight="semibold" sx={{mb: "10px"}}
       >
        {title}
    </Typography>
    <Typography variant="h4" fontWeight="300">
        {subtitle}
    </Typography>
  </Box>
    
  
}

export default Header;